/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intro_Mode_Three_Lives_DescriptionInputs */

const bn_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3টি ভুল উত্তরের পরে রান শেষ হয়।`)
};

const de_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Lauf endet nach 3 falschen Antworten.`)
};

const el_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η εκτέλεση τελειώνει μετά από 3 λανθασμένες απαντήσεις.`)
};

const en_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Run ends after 3 incorrect answers.`)
};

const es_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La ejecución finaliza después de 3 respuestas incorrectas.`)
};

const fr_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La partie se termine après 3 mauvaises réponses.`)
};

const hi_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 गलत उत्तरों के बाद रन समाप्त होता है।`)
};

const hu_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A futás 3 helytelen válasz után véget ér.`)
};

const id_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jalankan berakhir setelah 3 jawaban salah.`)
};

const it_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La corsa termina dopo 3 risposte errate.`)
};

const ja_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 回不正解になると実行が終了します。`)
};

const ko_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3번의 오답 후에 실행이 종료됩니다.`)
};

const nl_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De run eindigt na 3 foute antwoorden.`)
};

const pl_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Runda kończy się po 3 błędnych odpowiedziach.`)
};

const pt_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A corrida termina após 3 respostas incorretas.`)
};

const ru_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Забег заканчивается после 3-х неправильных ответов.`)
};

const sv_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Körningen slutar efter 3 felaktiga svar.`)
};

const tr_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Koşu 3 yanlış cevaptan sonra sona erer.`)
};

const uk_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пробіг закінчується після 3 неправильних відповідей.`)
};

const vi_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuộc chạy kết thúc sau 3 câu trả lời sai.`)
};

const zh_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 个错误答案后运行结束。`)
};

const zh_hant_intro_mode_three_lives_description = /** @type {(inputs: Intro_Mode_Three_Lives_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3 個錯誤答案後運行結束。`)
};

/**
* | output |
* | --- |
* | "Run ends after 3 incorrect answers." |
*
* @param {Intro_Mode_Three_Lives_DescriptionInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const intro_mode_three_lives_description = /** @type {((inputs?: Intro_Mode_Three_Lives_DescriptionInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intro_Mode_Three_Lives_DescriptionInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_intro_mode_three_lives_description(inputs)
	if (locale === "de") return de_intro_mode_three_lives_description(inputs)
	if (locale === "el") return el_intro_mode_three_lives_description(inputs)
	if (locale === "en") return en_intro_mode_three_lives_description(inputs)
	if (locale === "es") return es_intro_mode_three_lives_description(inputs)
	if (locale === "fr") return fr_intro_mode_three_lives_description(inputs)
	if (locale === "hi") return hi_intro_mode_three_lives_description(inputs)
	if (locale === "hu") return hu_intro_mode_three_lives_description(inputs)
	if (locale === "id") return id_intro_mode_three_lives_description(inputs)
	if (locale === "it") return it_intro_mode_three_lives_description(inputs)
	if (locale === "ja") return ja_intro_mode_three_lives_description(inputs)
	if (locale === "ko") return ko_intro_mode_three_lives_description(inputs)
	if (locale === "nl") return nl_intro_mode_three_lives_description(inputs)
	if (locale === "pl") return pl_intro_mode_three_lives_description(inputs)
	if (locale === "pt") return pt_intro_mode_three_lives_description(inputs)
	if (locale === "ru") return ru_intro_mode_three_lives_description(inputs)
	if (locale === "sv") return sv_intro_mode_three_lives_description(inputs)
	if (locale === "tr") return tr_intro_mode_three_lives_description(inputs)
	if (locale === "uk") return uk_intro_mode_three_lives_description(inputs)
	if (locale === "vi") return vi_intro_mode_three_lives_description(inputs)
	if (locale === "zh") return zh_intro_mode_three_lives_description(inputs)
	return zh_hant_intro_mode_three_lives_description(inputs)
});